import { defineStore } from 'pinia'
import api from '@/plugins/axios';
import router from '@/router';

export const useFormularioStore = defineStore('formulario', {
    state: () => ({
        doador: {
            nome: null,
            email: null,
            tipo_documento: "cpf",
            documento: null,
            cliente_id: 12,
            origem_id: 0,
            endereco: {
                pais: "Brasil",
                cep: null,
                logradouro: null,
                complemento: null,
                bairro: null,
                numero: null,
                cidade: null,
                estado: null
            },
            telefone: [
                {
                    ddi: +55,
                    telefone: null,
                    tipo_ligacao: null
                }
            ],
            enviar_sender: true,
            formulario_tipo: '4',
            bloquearDuplicidade: false
        },
        fatura: {
            campanha_id: 1752,
            valor: null,
            formaPagamento: null,
            dataCobranca: null,
            ip: null,
            origem_id: 0,
            intervalo: 1,
            parcela: 1
        },

        valor_doacao: null,
        outro_valor: null,
        valor_float: null,
        nao_quero_colaborar: null,
        confirme_email: null,
        whatsapp: null,
        forma_pagamento: null,
        termos_condicoes: null,

        // Cartão de crédito
        numero_cartao: null,
        exp_cartao: null,
        cvv: null,
        nome_titular: null,
        cpf_titular: null,
        bandeira_cartao: null,

        errors: {},
        validated: {},

        retorno_doacao: null,
        pix_imagem: null,
        pix_codigo: null,
        mensagem_copia: null,
        boleto_codigo: null,
        boleto_url: null,
        mensagem_boleto: null,
        transicao: null
    }),
    getters: {
        // double: state => state.count * 2,
    },
    actions: {
        resetaFormulario() {
            // Doador
            this.doador.nome = null
            this.doador.email = null
            this.doador.documento = null
            this.doador.endereco.cep = null
            this.doador.endereco.logradouro = null
            this.doador.endereco.complemento = null
            this.doador.endereco.bairro = null
            this.doador.endereco.numero = null
            this.doador.endereco.cidade = null
            this.doador.endereco.estado = null
            this.doador.telefone[0].telefone = null
            this.fatura.valor = null
            this.fatura.formaPagamento = null
            this.fatura.dataCobranca = null
            this.fatura.ip = null
            // Fora de Doador
            this.valor_doacao = null
            this.outro_valor = null
            this.valor_float = null
            this.nao_quero_colaborar = null
            this.confirme_email = null
            this.whatsapp = null
            this.forma_pagamento = null
            this.termos_condicoes = null

            // Cartão de crédito
            this.numero_cartao = null
            this.exp_cartao = null
            this.cvv = null
            this.nome_titular = null
            this.cpf_titular = null
            this.bandeira_cartao = null

            this.errors = {}
            this.validated = {}

            this.retorno_doacao = null
            this.pix_imagem = null
            this.pix_codigo = null
            this.mensagem_copia = null
            this.boleto_codigo = null
            this.boleto_url = null
            this.mensagem_boleto = null
            this.transicao = null
        },
        setValorDoacao() {
            this.valor_doacao = null
            this.nao_quero_colaborar = false
        },
        setValorOutroValor() {
            // this.outro_valor = null;
            this.outro_valor = 0
            this.nao_quero_colaborar = false
        },
        setNaoQueroColaborar() {
            this.valor_doacao = null
            this.outro_valor = null
            this.forma_pagamento = null
            this.nao_quero_colaborar = true
        },
        setFormaDePagamento() {
            this.nao_quero_colaborar = false
        },
        async validacao() {
            let mensagem = 'Enviando os seus dados para envio da estampa...'

            if (this.forma_pagamento) {
                switch (this.forma_pagamento) {
                    case "credito":
                        mensagem = 'Realizando doação...'
                        break;
                    case "pix":
                        mensagem = 'Gerando o qrCode Pix...'
                        break;
                    case "boleto":
                        mensagem = 'Gerando o boleto...'
                        break;
                    case "paypal":
                        mensagem = 'Redirecionando para o paypal...'
                        break;
                    default:
                        break;
                }
            }

            const alerta = this.$swal.fire({
                // title: 'Mensagem da Store',
                text: mensagem,
                icon: 'info',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    this.$swal.showLoading()
                },
            })

            this.errors = {}
            this.validated = {}
            this.campos()

            if (Object.keys(this.errors).length === 0) {
                // Aqui formato o post para envio para API de Doação.
                if (this.forma_pagamento) {
                    if (this.valor_doacao) {
                        this.fatura.valor = this.valor_doacao
                    } else {
                        this.fatura.valor = this.valor_float
                    }

                    this.fatura.formaPagamento = this.forma_pagamento
                    this.fatura.dataCobranca = new Date().toISOString().split('T')[0]

                    switch (this.forma_pagamento) {
                        case 'credito':
                            this.fatura.formaPagamento = "cred_vindi"
                            this.fatura.credito = {
                                nomeTitular: this.nome_titular,
                                numero: this.numero_cartao,
                                bandeira: this.bandeira_cartao,
                                digito: this.cvv,
                                validade: this.exp_cartao
                            }
                            break;
                        case 'pix':
                            this.fatura.pix = {
                                formaPagamento: this.forma_pagamento,
                                campanha_id: this.fatura.campanha_id,
                                valor: this.fatura.valor,
                                origem_id: this.fatura.origem_id ? this.fatura.origem_id : this.doador.origem_id,
                            }
                            break;
                        case 'boleto':
                            this.fatura.boleto = {
                                formaPagamento: this.forma_pagamento,
                                campanha_id: this.fatura.campanha_id,
                                valor: this.fatura.valor,
                                origem_id: this.fatura.origem_id ? this.fatura.origem_id : this.doador.origem_id,
                            }
                            break;
                        case 'paypal':
                            this.fatura.paypal = {
                                urlRetorno: "https://www.reginafidei.com.br/api-du-dm/du-pmkpay/retorno_paypal.php",
                                urlCancelamento: window.location.origin + router.resolve({ name: 'agradecimento-doacao' }).href
                            }
                            this.fatura.urlConclusao = window.location.origin + router.resolve({ name: 'agradecimento-doacao' }).href
                            this.fatura.currency = "BRL"
                            break;
                        default:
                            //
                            break;
                    }

                    try {
                        // ENVIA DOACAO
                        const post = {
                            doador: this.doador,
                            fatura: this.fatura
                        }

                        const response = await api.post('/doacao/doacao-du', post)
                        if (response.data && response.data.success) {
                            alerta.close()
                            if (response.data.success == true) {
                                if (this.forma_pagamento == "credito") {
                                    window.location.href = '/estampapadrepio/agradecimento-doacao'
                                }

                                if (this.forma_pagamento == "pix") {
                                    this.pix_imagem = response.data.pix.imagem
                                    this.pix_codigo = response.data.pix.qrcode
                                }

                                if (this.forma_pagamento == "boleto") {
                                    this.boleto_codigo = response.data.boleto.codigo_barras
                                    this.boleto_url = response.data.boleto.url
                                }

                                if (this.forma_pagamento == "paypal") {
                                    window.location.href = response.data.urlLocation
                                }
                            } else {
                                let mensagemErro = "Não foi possivel finalizar o cadastro."
                                if (this.forma_pagamento) {
                                    mensagemErro = "Não foi possivel realizar a doacao."
                                }
                                this.$swal.fire({
                                    text: mensagemErro,
                                    icon: 'warning',
                                    confirmButtonText: 'Confirmar',
                                    customClass: {
                                        confirmButton: 'btn btn-success',
                                    },
                                })
                            }
                        } else {
                            throw new Error(response.data)
                        }
                    } catch (error) {
                        alerta.close()
                        let mensagemErro = "Não foi possivel finalizar o cadastro."
                        if (this.forma_pagamento) {
                            mensagemErro = "Não foi possivel realizar a doacao."
                        }
                        this.$swal.fire({
                            text: mensagemErro,
                            icon: 'warning',
                            confirmButtonText: 'Confirmar',
                            customClass: {
                                confirmButton: 'btn btn-success',
                            },
                        })
                        console.error('Erro na requisicao: ', error)
                    }
                }

                // ENVIA HF
                if (this.nao_quero_colaborar) {
                    try {
                        let post = {
                            nome: this.doador.nome,
                            email: this.doador.email,
                            campanha: 1843,
                            cliente_id: this.doador.cliente_id,
                            documento: this.doador.documento,
                            pais: this.doador.endereco.pais,
                            cep: this.doador.endereco.cep,
                            logradouro: this.doador.endereco.logradouro,
                            numero: this.doador.endereco.numero,
                            bairro: this.doador.endereco.bairro,
                            cidade: this.doador.endereco.cidade,
                            estado: this.doador.endereco.estado,
                            origem_id: this.fatura.origem_id ? this.fatura.origem_id : this.doador.origem_id,
                            telefone: this.doador.telefone,
                            enviar_erp: true,
                            formulario_tipo: '4',
                            verifica_fatura_campanha: [1752, 1753, 1754, 1843]
                        }

                        if (this.doador.endereco.complemento) {
                            post.complemento = this.doador.endereco.complemento
                        }

                        const response = await api.post('/api/gerarhousefile', post)
                        if (response.data && response.data.success) {
                            this.resetaFormulario()
                            alerta.close()
                            window.location.href = '/estampapadrepio/agradecimento-cadastro';
                        } else {
                            if (response.data.jaRecebeuPresente) {
                                this.$swal.fire({
                                    text: "O seu pedido da Estampa do Padre Pio já foi cadastrado.",
                                    icon: 'warning',
                                    confirmButtonText: 'Confirmar',
                                    customClass: {
                                        confirmButton: 'btn btn-success',
                                    },
                                })
                            } else {
                                throw new Error('Falha com api.')
                            }
                        }
                    } catch (error) {
                        alerta.close()
                        this.$swal.fire({
                            text: "Não foi possivel finalizar o cadastro.",
                            icon: 'warning',
                            confirmButtonText: 'Confirmar',
                            customClass: {
                                confirmButton: 'btn btn-success',
                            },
                        })
                    }

                }
            } else {
                alerta.close()
            }
        },
        campos() {
            if (!this.doador.nome) {
                this.errors.nome = 'Informe o nome e sobrenome.'
            } else {
                let nome = this.doador.nome.trim()
                const regexNome = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/
                const partesDoNome = nome.split(' ').filter(Boolean)
                if (regexNome.test(nome)) {
                    if (partesDoNome.length < 2) {
                        this.errors.nome = 'Nome ínvalido.'
                    } else {
                        this.validated.nome = true
                    }
                } else {
                    this.errors.nome = 'Nome ínvalido.'
                }
            }

            if (!this.doador.endereco.cep) {
                this.errors.cep = 'Informe o cep.'
            } else {
                if (this.doador.endereco.cep.length < 9) {
                    this.errors.cep = 'Cep ínvalido.'
                } else {
                    this.validated.cep = true
                }
            }

            if (!this.doador.endereco.cidade) {
                this.errors.cidade = 'Informe a cidade.'
            } else {
                this.validated.cidade = true
            }

            if (!this.doador.endereco.bairro) {
                this.errors.bairro = 'Informe o bairro.'
            } else {
                this.validated.bairro = true
            }

            if (!this.doador.endereco.logradouro) {
                this.errors.endereco = 'Informe o endereço.'
            } else {
                this.validated.endereco = true
            }

            if (!this.doador.endereco.numero) {
                this.errors.numero = 'Informe o número.'
            } else {
                this.validated.numero = true
            }

            if (!this.doador.endereco.estado) {
                this.errors.estado = 'Informe o estado.'
            } else {
                this.validated.estado = true
            }

            if (!this.doador.email) {
                this.errors.email = 'Informe o email.'
            } else {
                this.validated.email = true
            }

            if (!this.confirme_email) {
                this.errors.confirme_email = 'Confirme o seu email.'
            } else {
                if (this.confirme_email != this.doador.email) {
                    this.errors.confirme_email = 'Confirme o seu email.'
                } else {
                    this.validated.confirme_email = true
                }
            }

            if (!this.doador.documento) {
                this.errors.documento = 'Informe o CPF.'
            } else {
                let documento = this.doador.documento.replace(/[^\d]/g, '')
                if (documento.length !== 11) {
                    this.errors.documento = 'CPF inválido.'
                } else {
                    if (/^(\d)\1{10}$/.test(documento)) {
                        this.errors.documento = 'CPF inválido.'
                    } else {
                        let soma = 0;
                        for (let i = 0; i < 9; i++) {
                            soma += parseInt(documento.charAt(i)) * (10 - i)
                        }
                        let resto = soma % 11
                        let digitoVerificador1 = resto < 2 ? 0 : 11 - resto
                        if (digitoVerificador1 !== parseInt(documento.charAt(9))) {
                            this.errors.documento = 'CPF inválido.'
                        } else {
                            // Calcula e verifica o segundo dígito verificador
                            soma = 0;
                            for (let i = 0; i < 10; i++) {
                                soma += parseInt(documento.charAt(i)) * (11 - i)
                            }
                            resto = soma % 11
                            let digitoVerificador2 = resto < 2 ? 0 : 11 - resto
                            if (digitoVerificador2 !== parseInt(documento.charAt(10))) {
                                this.errors.documento = 'CPF inválido.'
                            } else {
                                this.validated.documento = true
                            }
                        }

                    }
                }
            }

            // if (!this.termos_condicoes) {
            //     this.errors.termos_condicoes = 'Você precisa aceitar os termos e condições.'
            // }

            if (!this.nao_quero_colaborar) {
                if (!this.valor_doacao) {
                    if (this.outro_valor != "0,00") {
                        const valorFloat = this.outro_valor.replace(',', '.')
                        if (valorFloat < 20) {
                            this.errors.doacao = 'Informe um valor de 20 reais ou mais.'
                        } else {
                            this.valor_float = valorFloat
                        }
                    } else {
                        this.errors.doacao = 'Informe ou selecione o valor de doação.'
                    }
                }



                if (!this.forma_pagamento) {
                    this.errors.forma_pagamento = 'Escolha a forma de pagamento.'
                }
            }

            if (this.whatsapp && this.whatsapp.length < 15) {
                this.errors.whatsapp = 'Informe um número válido.'
            }

            if (this.whatsapp && this.whatsapp.length == 15) {
                this.validated.whatsapp = true
                this.doador.telefone[0].telefone = this.whatsapp.replace(/\s|-/g, "")
            }

            if (this.forma_pagamento == "credito") {
                if (!this.numero_cartao) {
                    this.errors.numero_cartao = 'Informe o número do cartão de crédito.'
                } else {
                    const numero_cartao = this.numero_cartao.replace(/\s+/g, '').trim();
                    if (numero_cartao.length < 16) {
                        this.errors.numero_cartao = 'Cartão de crédito ínvalido.'
                    } else {
                        this.validated.numero_cartao = true
                    }
                }

                if (!this.exp_cartao) {
                    this.errors.exp_cartao = 'Informe a data de expiração do cartão de crédito.'
                } else {
                    const regex = /^(0[1-9]|1[0-2])\/(\d{2})$/
                    if (!regex.test(this.exp_cartao)) {
                        this.errors.exp_cartao = 'Expiração do cartão de crédito inválido.'
                    } else {
                        const [mes, ano] = this.exp_cartao.split('/')
                        const mesExpiracao = parseInt(mes, 10)
                        const anoExpiracao = parseInt(ano, 10)

                        const anoAtual = new Date().getFullYear() % 100

                        if (anoExpiracao < anoAtual || (anoExpiracao === anoAtual && mesExpiracao < new Date().getMonth() + 1)) {
                            this.errors.exp_cartao = 'Expiração do cartão de crédito inválido.'
                        } else {
                            this.validated.exp_cartao = true
                        }
                    }
                }

                if (!this.bandeira_cartao) {
                    this.errors.bandeira_cartao = 'Informe a bandeira do cartão de crédito.'
                } else {
                    this.validated.bandeira_cartao = true
                }

                if (!this.cvv) {
                    this.errors.cvv = 'Informe o CVV do seu cartão de crédito.'
                } else {
                    const regex = /^[0-9]{3,4}$/;
                    let regexCvv = regex.test(this.cvv)
                    if (!regexCvv) {
                        this.errors.cvv = 'CVV ínvalido.'
                    } else {
                        this.validated.cvv = true
                    }
                }

                if (!this.nome_titular) {
                    this.errors.nome_titular = 'Informe o nome do titular.'
                } else {
                    let nome_titular = this.nome_titular.trim()
                    const regexNome = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/
                    const partesDoNome = nome_titular.split(' ').filter(Boolean)
                    if (regexNome.test(nome_titular)) {
                        if (partesDoNome.length < 2) {
                            this.errors.nome_titular = 'Informe o nome conforme está no cartão de crédito.'
                        } else {
                            this.validated.nome_titular = true
                        }
                    } else {
                        this.errors.nome_titular = 'Informe o nome conforme está no cartão de crédito.'
                    }
                }

                if (!this.cpf_titular) {
                    this.errors.cpf_titular = 'Informe o Cpf do titular do cartão de crédito.'
                } else {
                    let cpf_titular = this.cpf_titular.replace(/[^\d]/g, '')
                    if (cpf_titular.length !== 11) {
                        this.errors.cpf_titular = 'CPF do titular inválido.'
                    } else {
                        if (/^(\d)\1{10}$/.test(cpf_titular)) {
                            this.errors.cpf_titular = 'CPF do titular inválido.'
                        } else {
                            let soma = 0;
                            for (let i = 0; i < 9; i++) {
                                soma += parseInt(cpf_titular.charAt(i)) * (10 - i)
                            }
                            let resto = soma % 11
                            let digitoVerificador1 = resto < 2 ? 0 : 11 - resto
                            if (digitoVerificador1 !== parseInt(cpf_titular.charAt(9))) {
                                this.errors.cpf_titular = 'CPF do titular inválido.'
                            } else {
                                // Calcula e verifica o segundo dígito verificador
                                soma = 0;
                                for (let i = 0; i < 10; i++) {
                                    soma += parseInt(cpf_titular.charAt(i)) * (11 - i)
                                }
                                resto = soma % 11
                                let digitoVerificador2 = resto < 2 ? 0 : 11 - resto
                                if (digitoVerificador2 !== parseInt(cpf_titular.charAt(10))) {
                                    this.errors.cpf_titular = 'CPF do titular inválido.'
                                } else {
                                    this.validated.cpf_titular = true
                                }
                            }
                        }
                    }
                }
            }
        },
        bandeiraCartao() {
            const numero_credito = this.numero_cartao.replace(/\s+/g, '').trim();
            const bandeiras = [
                { nome: 'visa', regex: /^4[0-9]{12}(?:[0-9]{3})?$/ },
                { nome: 'mastercard', regex: /^5[1-5][0-9]{14}$/ },
                { nome: 'elo', regex: /^(4011(78|79)|431274|438935|457631|457632|504175|5067[0-6]|50677|509[0-9]{2}|627780|636297|636368|650[4-9][0-9]{2}|6516[0-9]{2}|6550[0-9]{2})/ },
                { nome: 'amex', regex: /^3[47][0-9]{13}$/ },
                { nome: 'diners', regex: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/ },
                // { nome: 'Discover', regex: /^6(?:011|5[0-9]{2})[0-9]{12}$/ },
                // { nome: 'JCB', regex: /^(?:2131|1800|35\d{3})\d{11}$/ },
                { nome: 'hipercard', regex: /^(606282|637095|637568|637599|637609|637612)[0-9]{10,12}$/ }
            ];

            const bandeira = bandeiras.find(b => b.regex.test(numero_credito))
            if (bandeira) {
                this.bandeira_cartao = bandeira.nome
            } else {
                this.bandeira_cartao = null
            }
        },
        transicaoForm() {
            if (this.numero_cartao.length > 0) {
                this.transicao = true
            } else {
                this.transicao = null
            }
        },

        async buscarEndereco() {
            if (this.doador.endereco.cep) {
                const cep = this.doador.endereco.cep.replace(/\D/g, "")
                if (cep.length == 8) {
                    try {
                        const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`)
                        const data = await response.json()
                        if (data.erro) {
                            // console.log("Erro ao buscar cep.")
                        } else {
                            this.doador.endereco.bairro = data.bairro
                            this.doador.endereco.estado = data.uf
                            this.doador.endereco.cidade = data.localidade
                            this.doador.endereco.logradouro = data.logradouro
                        }
                    } catch (error) {
                        // console.log("Erro ao buscar cep.")
                    }
                }
            }
        }
    },
})